import React from 'react'
import Content from './Content'
import Sidebar from './Sidebar'
import RecoveryView from './checkoutRecovery/RecoveryView'
import Loader from '../search-trip/components/Loader'
import { useReservationContext } from './ReservationContext'

const ReservationPage = () => {
    const {
        isRecovery,
        loading,
        recoveryError,
        retryWithoutPromotionCodes,
        recoveryFallbackUrl,
        t,
    } = useReservationContext()

    if (!isRecovery) {
        return (
            <div className="trip-reservation">
                <Sidebar />
                <Content />
            </div>
        )
    }

    if (loading) {
        return (
            <div className="trip-reservation__loading-container">
                <Loader />
            </div>
        )
    }

    if (recoveryError) {
        return (
            <div className="trip-reservation">
                <div className="trip-reservation__right">
                    <section
                        className="trip-reservation__section"
                        role="alert"
                    >
                        <h1>{t('recovery.restoreFailed')}</h1>
                        <p>{t(recoveryError)}</p>

                        <button
                            type="button"
                            className="trip-reservation__btn"
                            onClick={() => window.location.reload()}
                        >
                            {t('recovery.retry')}
                        </button>

                        {recoveryError === 'recovery.promotionsUnavailable' && (
                            <button
                                type="button"
                                className="trip-reservation__btn"
                                onClick={retryWithoutPromotionCodes}
                            >
                                {t('recovery.retryWithoutPromotionCodes')}
                            </button>
                        )}

                        {recoveryFallbackUrl && (
                            <p>
                                <a href={recoveryFallbackUrl}>
                                    {t('recovery.search')}
                                </a>
                            </p>
                        )}
                    </section>
                </div>
            </div>
        )
    }

    return (
        <div className="trip-reservation">
            <Sidebar showTransportExtras={false} />
            <RecoveryView />
        </div>
    )
}

export default ReservationPage
